// Generated by scripts/sync-tutorial-videos.cjs from youtube-upload-manifest.json.
// Do not edit individual URLs here; update the manifest and rerun the script.

export const TUTORIAL_VIDEOS = [
  {
    key: "onboarding-main-16x9",
    topic: "Primeros pasos",
    title: "Facturas Simples: configure su empresa y empiece a emitir DTE",
    description: "Tutorial principal de Facturas Simples para configurar su empresa, completar el asistente inicial y preparar la emision de Documentos Tributarios Electronicos (DTE) en El Salvador.",
    format: "16:9",
    youtubeUrl: "https://youtu.be/Oz5MFyAEPcw",
  },
  {
    key: "onboarding-mobile-9x16",
    topic: "Primeros pasos",
    title: "Configure Facturas Simples desde Android o iPhone",
    description: "Recorrido movil para configurar su empresa en Facturas Simples y preparar sus pruebas DTE desde Android o iPhone.",
    format: "9:16",
    youtubeUrl: "https://youtube.com/shorts/DVuDSRuE8Ds",
  },
  {
    key: "production-access-16x9",
    topic: "Certificación",
    title: "Solicitar autorizacion a produccion para emitir DTE",
    description: "Tutorial para generar y enviar documentos de prueba desde Facturas Simples antes de solicitar la autorizacion final de produccion ante Hacienda.",
    format: "16:9",
    youtubeUrl: "https://youtu.be/orPxbsJZKTU",
  },
  {
    key: "compras-16x9",
    topic: "Compras",
    title: "Compras en Facturas Simples: importe facturas desde Gmail",
    description: "Tutorial del modulo Compras: registre facturas recibidas, conecte Gmail mediante IMAP y organice sus DTE de proveedores.",
    format: "16:9",
    youtubeUrl: "https://youtu.be/454_6WsxSzA",
  },
  {
    key: "cuentas-16x9",
    topic: "Cobros y pagos",
    title: "Cobros y pagos: cuentas por cobrar y por pagar",
    description: "Conozca como controlar saldos locales de cuentas por cobrar y cuentas por pagar en Facturas Simples.",
    format: "16:9",
    youtubeUrl: "https://youtu.be/mIU3N1x2c6M",
  },
  {
    key: "productos-16x9",
    topic: "Productos",
    title: "Productos, inventario y alertas de stock",
    description: "Aprenda a gestionar productos y servicios, controlar inventario y detectar productos con stock bajo en Facturas Simples.",
    format: "16:9",
    youtubeUrl: "https://youtu.be/P3R9ykZFx2U",
  },
  {
    key: "archivar-16x9",
    topic: "Productos",
    title: "Archivar productos en Facturas Simples",
    description: "Aprenda a archivar productos que ya no vende para mantener limpio su catalogo sin borrar el historial ni afectar documentos anteriores.",
    format: "16:9",
    youtubeUrl: "https://youtu.be/d_MHSOPArd8",
  },
  {
    key: "archivar-9x16",
    topic: "Productos",
    title: "Archive productos sin perder historial",
    description: "Version movil sobre la funcion de archivar productos en Facturas Simples.",
    format: "9:16",
    youtubeUrl: "https://youtube.com/shorts/TmIGag0f9sI",
  }
];

export function getPublishedTutorialVideos() {
  return TUTORIAL_VIDEOS.filter((video) => Boolean(video.youtubeUrl));
}

export function youtubeEmbedUrl(url) {
  const value = String(url || '').trim();
  if (!value) return '';

  const patterns = [
    /youtube\.com\/watch\?[^#]*v=([^&#]+)/i,
    /youtu\.be\/([^?&#/]+)/i,
    /youtube\.com\/embed\/([^?&#/]+)/i,
    /youtube\.com\/shorts\/([^?&#/]+)/i,
  ];

  for (const pattern of patterns) {
    const match = value.match(pattern);
    if (match?.[1]) return `https://www.youtube.com/embed/${encodeURIComponent(match[1])}`;
  }

  return '';
}
